module.exports = __webpack_public_path__ + "img/2ne.14166bdc.svg";